import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { TableDiffPreview } from "components/ReportNodeTextBlock/TableDiffPreview"
import { DataNode } from "graphql/types"
import { useStoreState } from "hooks/storeHooks"
import { default as Markdown } from "markdown-to-jsx"

type ReportNodeTableBoxWithDiffProps = {
  data: DataNode
}

export const ReportNodeTableBoxWithDiff = (props: ReportNodeTableBoxWithDiffProps) => {
  const { data } = props
  const { textBlocks } = useStoreState((state) => state)

  // Helper function to get original DataNode
  const getOriginalDataNode = (dataNode: DataNode): DataNode | null => {
    if (!dataNode.originalTextblockId || dataNode.originalTextBlockDataNodeNo === undefined) {
      return null
    }

    const textBlock = textBlocks.find((tb) => tb.id === dataNode.originalTextblockId)
    if (!textBlock || dataNode.originalTextBlockDataNodeNo === null) {
      return null
    }

    return textBlock.block[dataNode.originalTextBlockDataNodeNo] || null
  }

  const originalDataNode = getOriginalDataNode(data)

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption">
        Table {data.tableNumber}: {data.tableCaption}
      </Typography>
      <Table size="small" sx={{ border: "2px solid", borderColor: "divider" }}>
        <TableHead>
          <TableRow>
            {data.tableHeader.map((header, index) => (
              <TableCell
                key={index}
                sx={{ border: "2px solid", borderColor: "divider" }}
                colSpan={header.colSpan}
              >
                <Markdown options={{ forceBlock: false }}>{header.data}</Markdown>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.tableBody.map((row, rowIndex) => (
            <TableRow key={rowIndex} style={{ whiteSpace: "pre-wrap" }}>
              {row.map((cell, cellIndex) => (
                <TableCell
                  key={cellIndex + "-" + rowIndex}
                  colSpan={cell.colSpan}
                  sx={{ border: "2px solid", borderColor: "divider" }}
                >
                  <Markdown options={{ forceBlock: false }}>{cell.data}</Markdown>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Show diff preview if there are changes */}
      {originalDataNode && (
        <TableDiffPreview originalDataNode={originalDataNode} currentDataNode={data} />
      )}
    </Box>
  )
}
